import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';
import {
    Group as GroupIcon,
    Home as HomeIcon,
    AttachMoney as AttachMoneyIcon,
    SentimentSatisfiedAlt as SentimentSatisfiedAltIcon,
    CheckCircle as CheckCircleIcon,
    TipsAndUpdates as TipsAndUpdatesIcon,
    MeetingRoom as MeetingRoomIcon,
    Info as InfoIcon
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ミドル世代ルームシェアの新潮流と導入
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('background')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ミドル世代増加の背景
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('types')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    同世代・異世代シェアの特徴
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('economy')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    経済的メリットと現実的な費用感
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('loneliness')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    孤独対策としての効果
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('property')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    物件選びの注意点とポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    7.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめとこれからのルームシェア
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button 
                    variant="outlined" 
                    size="small" 
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ミドル世代ルームシェアの新潮流と導入
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    近年、40代・50代を中心とした「ミドル世代」のルームシェアが静かなブームを迎えています。これまでルームシェアといえば若い世代の住まい方というイメージが強かったものの、人生100年時代が現実となった今、柔軟で新しいライフスタイルを求めるミドル世代が注目しています。
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    「経済的なゆとりを保ちたい」「孤独を避けたい」「価値観の合う仲間と新しい暮らしを楽しみたい」——そんな願いを叶える選択肢として、ルームシェアは再評価されつつあります。本記事では、ミドル世代のルームシェアの現状やメリット、失敗しない物件選びのポイントまで、専門的な視点で詳しく解説します。
                </Typography>
            </Box>

            {/* セクション1: 背景 */}
            <Box id="background" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ミドル世代増加の背景
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={7}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            高齢化・単身化が進む現代日本。40代・50代で独身や単身生活を選ぶ人が増えたことで、住まい方に新しい選択肢が求められるようになりました。特に以下の3つの背景が、ミドル世代ルームシェア増加の原動力です。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon><GroupIcon color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography fontWeight="bold">1. 単身世帯の増加</Typography>}
                                    secondary="一人暮らしの40代・50代が年々増加し、単身者の生活の質や安心感が重視されるようになった"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><TipsAndUpdatesIcon color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography fontWeight="bold">2. ライフステージの多様化</Typography>}
                                    secondary="離婚や子育て後の再出発、転職・転居など、人生の転機にルームシェアを選ぶケースが増加"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><AttachMoneyIcon color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography fontWeight="bold">3. 住居費高騰への対応</Typography>}
                                    secondary="都市部を中心に家賃・光熱費が上昇する中、シェアによる節約志向が広がっている"
                                />
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ p: 1 }}>
                            <img
                                src="/images/blog/modern-middle-share_middle-generation-roomshare-benefits.jpg"
                                alt="明るいダイニングで40代・50代の男女3人がコーヒーを片手に笑顔で会話している、落ち着いたトーンのルームシェア風景。ミドル世代の交流と安心感が伝わる"
                                style={{ width: '100%', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.07)' }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* セクション2: 同世代・異世代シェアの特徴 */}
            <Box id="types" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    同世代・異世代シェアの特徴
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ミドル世代のルームシェアは、大きく「同世代シェア」「異世代シェア」の2タイプに分けられます。それぞれに特徴とメリットがあり、ライフスタイルや価値観に合った形を選ぶことが重要です。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 1 }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                <GroupIcon color="primary" sx={{ mr: 1, verticalAlign: 'middle' }}/>
                                同世代シェア
                            </Typography>
                            <List>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="価値観や生活リズムが似ていてストレスが少ない" />
                                </ListItem>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="人生経験や悩みを分かち合える" />
                                </ListItem>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="生活ペースや将来設計も相談しやすい" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 1 }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                <GroupIcon color="secondary" sx={{ mr: 1, verticalAlign: 'middle' }}/>
                                異世代シェア
                            </Typography>
                            <List>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon><CheckCircleIcon color="info" /></ListItemIcon>
                                    <ListItemText primary="新鮮な価値観や刺激を得られる" />
                                </ListItem>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon><CheckCircleIcon color="info" /></ListItemIcon>
                                    <ListItemText primary="生活の幅や人間関係が広がる" />
                                </ListItem>
                                <ListItem sx={{ pl: 0 }}>
                                    <ListItemIcon><CheckCircleIcon color="info" /></ListItemIcon>
                                    <ListItemText primary="お互いの得意分野を活かした協力が生まれやすい" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    自分の性格や目的、将来のビジョンに合わせて、最適なシェアスタイルを選ぶのが成功の近道です。
                </Typography>
            </Box>

            {/* セクション3: 経済的メリット */}
            <Box id="economy" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    経済的メリットと現実的な費用感
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            ルームシェア最大の魅力は、やはり「経済的メリット」です。特にミドル世代にとっては、今後の人生設計や余暇を充実させるためにも住居費の圧縮は重要なポイントとなります。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon><AttachMoneyIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="家賃・光熱費・インターネットなどをシェアできる" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><AttachMoneyIcon color="secondary" /></ListItemIcon>
                                <ListItemText primary="広い物件や充実した設備をリーズナブルに利用可能" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><AttachMoneyIcon color="success" /></ListItemIcon>
                                <ListItemText primary="食費や日用品も分担で節約効果" />
                            </ListItem>
                        </List>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            例えば都内2LDK（家賃16万円）を2人でシェアすれば、月8万円＋光熱費で快適な生活空間が手に入ります。
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ p: 1 }}>
                            
                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Box>
                    <Typography variant="h6" gutterBottom>
                        <AttachMoneyIcon sx={{ verticalAlign: 'middle', mr: 1 }} color="primary" />
                        ミドル世代ルームシェアの費用モデル（例）
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Paper sx={{ p: 2, borderRadius: 2 }}>
                                <Typography variant="body2" color="text.secondary">一人暮らし</Typography>
                                <Divider sx={{ my: 1 }} />
                                <ListItemText primary="家賃：13万円" secondary="光熱費：1.5万円" />
                                <Divider sx={{ my: 1 }} />
                                <Typography variant="body2" color="text.secondary">合計：約14.5万円/月</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={6}>
                            <Paper sx={{ p: 2, borderRadius: 2, bgcolor: '#e3f2fd' }}>
                                <Typography variant="body2" color="primary">2人でルームシェア</Typography>
                                <Divider sx={{ my: 1 }} />
                                <ListItemText primary="家賃：8万円" secondary="光熱費：0.8万円" />
                                <Divider sx={{ my: 1 }} />
                                <Typography variant="body2" color="primary">合計：約8.8万円/月</Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        浮いたコストで趣味や旅行、自己投資など、人生の幅を広げることができます。
                    </Typography>
                </Box>
            </Box>

            {/* セクション4: 孤独対策としての効果 */}
            <Box id="loneliness" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    孤独対策としての効果
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Box sx={{ p: 1 }}>
                            
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            近年注目される「孤独・孤立」の課題。特にミドル世代は、仕事や家庭環境の変化などで孤独感を抱えやすい傾向があります。ルームシェアは、日常のちょっとした会話や食事の共有を通じて、自然なつながりや安心感をもたらします。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon><SentimentSatisfiedAltIcon color="success" /></ListItemIcon>
                                <ListItemText primary="さりげない会話や気配が心の支えに" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><SentimentSatisfiedAltIcon color="success" /></ListItemIcon>
                                <ListItemText primary="体調不良時や緊急時も安心" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><SentimentSatisfiedAltIcon color="success" /></ListItemIcon>
                                <ListItemText primary="趣味やイベントの共有で生活に彩り" />
                            </ListItem>
                        </List>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            無理にべったりする必要はありません。「適度な距離感」を保ちつつ、心地よい安心感を得られるのがミドル世代ルームシェアの魅力です。
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            {/* セクション5: 物件選びの注意点 */}
            <Box id="property" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    物件選びの注意点とポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={7}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            ルームシェアを成功させるカギは「物件選び」にあります。特にミドル世代は、生活スタイルやプライバシーへの配慮が重要です。物件探しの際は、以下のポイントを必ずチェックしましょう。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon><HomeIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="各個室の広さ・収納力" secondary="自分だけの空間がしっかり確保できるか" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><MeetingRoomIcon color="secondary" /></ListItemIcon>
                                <ListItemText primary="共用部の使いやすさ" secondary="キッチン・バス・トイレなどの動線や清潔感" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                <ListItemText primary="防音・セキュリティ" secondary="音やプライバシー、女性の安心感なども大切" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><CheckCircleIcon color="info" /></ListItemIcon>
                                <ListItemText primary="契約形態・ルールの明確さ" secondary="トラブル回避のための約束事や契約内容を事前に確認" />
                            </ListItem>
                        </List>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            「お互いの生活リズムを尊重できる間取りか」「長期的に住みやすい環境か」など、見学時にしっかりチェックしましょう。
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ p: 1 }}>
                            
                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Box>
                    <Typography variant="h6" gutterBottom>
                        <InfoIcon sx={{ verticalAlign: 'middle', mr: 1 }} color="primary" />
                        失敗しないためのチェックリスト
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="希望条件は事前にリストアップ" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="内見時は必ず複数人でチェック" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="入居前にルールや役割分担を明確化" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="退去ルールやトラブル時の対処法も確認" />
                        </ListItem>
                    </List>
                </Box>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめとこれからのルームシェア
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    40代・50代のルームシェアは、単なる「コストダウン」以上の価値をもたらします。同じ人生経験を持った仲間とともに、安心・快適・豊かな毎日を手に入れることができる。それがミドル世代ルームシェアの最大の魅力です。
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    もちろん、実際に住み始める前には十分な準備と相性の確認、物件選びの慎重さが必要です。ですが、そのハードルを乗り越えれば、新しい人生の扉が開かれるはず。今後ますます多様化する「住まい方」の一つとして、ぜひミドル世代のルームシェアにチャレンジしてみてください。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    <Chip label="ミドル世代" color="primary" variant="outlined" />
                    <Chip label="ルームシェア" color="primary" variant="outlined" />
                    <Chip label="孤独対策" color="secondary" variant="outlined" />
                    <Chip label="家賃節約" color="success" variant="outlined" />
                    <Chip label="新しい住まい方" color="default" variant="outlined" />
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'middle-generation-roomshare-benefits',
    slug: 'middle-generation-roomshare-benefits',
    title: 'ミドル世代のルームシェア：40代・50代からの新しい住まい方のメリット',
    excerpt: 'ミドル世代ルームシェアの背景や特徴、経済的メリット、孤独対策、物件選びのポイントまで、専門的な視点でわかりやすく解説します。40代・50代からの豊かな住まい方を考える方に必見の情報です。',
    coverImage: '/images/blog/cover-middle-generation-roomshare_middle-generation-roomshare-benefits.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つミドル世代の男女たちがリラックスしながら談笑している様子。落ち着いた色調と温かな雰囲気が、安心感と新しい住まい方の魅力を象徴している',
    publishedAt: '2024-06-21T09:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', 'ミドル世代', 'ライフスタイル'],
    tags: ['ミドル世代', 'ルームシェア', '新しい住まい方', '孤独対策', '家賃節約'],
    author: {
        name: '高橋 直樹',
        avatar: '/images/avatars/naoki-takahashi.jpg',
        bio: '住宅・シェアライフ分野で15年以上活動。様々な年代の住まい選びとコミュニティ形成をサポートしてきた経験から、実践的でわかりやすい情報を発信。',
        profilePicture: '/images/avatars/naoki-takahashi.jpg'
    },
    viewCount: 1542,
    contentComponent: PostContent
};

export default post;